import React, { useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import SmartyAddressAutocomplete from './SmartyAddressAutocomplete';
import './EditAddressModal.css';

export default function EditAddressModal({ show, onClose, onSave, address, titleText }) {
  const [form, setForm] = useState({ ...address });
  const [addressInput, setAddressInput] = useState('');

  useEffect(() => {
    setForm({ ...address });
    // Set the address input to show the full address
    if (address.address1) {
      setAddressInput(`${address.address1}, ${address.city}, ${address.province_code} ${address.zip}`);
    }
  }, [address]);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleAddressSelect = (addressData) => {
    setForm(prev => ({
      ...prev,
      ...addressData
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(form);
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} centered dialogClassName="edit-address-modal">
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Edit {titleText}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <Form.Label>Name</Form.Label>
            <Form.Control
              required
              placeholder="Enter full name"
              value={form.name || ''}
              onChange={handleChange('name')}
            />
          </div>
          <div className="form-group">
            <Form.Label>Address</Form.Label>
            <SmartyAddressAutocomplete
              value={addressInput}
              onChange={setAddressInput}
              onAddressSelect={handleAddressSelect}
              placeholder="Start typing your address..."
            />
          </div>
          <div className="form-group">
            <Form.Label>Address Line 2 (Optional)</Form.Label>
            <Form.Control
              placeholder="Apartment, suite, etc."
              value={form.address2 || ''}
              onChange={handleChange('address2')}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" className="btn-save">
            Save Changes
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
